import { render, staticRenderFns } from "./FailureReview.vue?vue&type=template&id=3a7b4da4&scoped=true&"
import script from "./FailureReview.vue?vue&type=script&lang=js&"
export * from "./FailureReview.vue?vue&type=script&lang=js&"
import style0 from "./FailureReview.vue?vue&type=style&index=0&id=3a7b4da4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b4da4",
  null
  
)

export default component.exports